@let texts = resourcesService.languageFile.value();

<div id="questions-container">
  <gis-questions/>
</div>

<div id="score-bar-mobile-container" class="mobile-only">
  <gis-score-bar/>
</div>

<div id="attempt-and-hint-container" class="mobile-only">
  <div class="attempt-counter">
    {{ texts.attempt }}: {{ store.questionState().attempt }}/{{ store.maxAttemptsPerQuestion() }}
  </div>
  <div class="hint-container">
    <gis-hint [buttonPosition]="'right'"/>
  </div>
</div>

@if (store.questionState().feedback === 'correct' || store.questionState().feedback === 'wrong-and-over') {
  <div class="answer-container mobile-only">
    <gis-panel [buttonLabel]="texts.answerExplanation" [buttonIcon]="PanelButtonIcon.Info">
      <gis-answer [insidePanel]="true"/>
    </gis-panel>
  </div>
}

<div class="question-feedback-container mobile-only">
  <gis-question-feedback/>
</div>

@if (!store.error()) {
  <div id="stop-container" class="mobile-only">
    <p-button
      (onClick)="store.stopGame()"
      [text]="true"
      [style]="{display: 'flex', 'align-items': 'center', gap: '8px', 'padding-left': 0}">
      <span style="margin-top: 4px"><i class="pi pi-arrow-left"></i></span>
      <span style="color: black">{{ texts.stop }}</span>
    </p-button>
  </div>
}
